import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h-100 d-flex flex-column intranet" };
const _hoisted_2 = { class: "header-bar" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_intranet_layout__navbar = _resolveComponent("g-intranet-layout__navbar");
    const _component_g_intranet_layout__footer = _resolveComponent("g-intranet-layout__footer");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
            _createVNode(_component_g_intranet_layout__navbar)
        ]),
        _createElementVNode("div", {
            class: _normalizeClass([_ctx.widthMode === 'full' ? 'container-fluid' : 'container', 'py-3 px-5']),
            style: { "flex": "1 1 0", "order": "2" }
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 2),
        _createVNode(_component_g_intranet_layout__footer)
    ]));
}
